import { useAuth } from "@trillion/auth";
import { SignInForm } from "@trillion/ui/components/sign-in-form";
import { Shield } from "lucide-react";

export function LoginPage() {
  const { loginWithPassport } = useAuth();

  return (
    <SignInForm
      title="Passport Admin"
      description="Sign in with your Trillion Passport account"
      logo={
        <div className="flex size-12 items-center justify-center rounded-full bg-primary/10">
          <Shield className="size-6 text-primary" />
        </div>
      }
      showSsoButton
      onSsoClick={loginWithPassport}
      showLocalForm={false}
      onSubmit={async () => {}}
    />
  );
}
